import script from "./GroupDialogue.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupDialogue.vue?vue&type=script&setup=true&lang=js"

import "./GroupDialogue.vue?vue&type=style&index=0&id=45cc0e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cc0e80"]])

export default __exports__